module.exports = __webpack_public_path__ + "static/media/0k.9088505.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp4/0k.mp4
// module id = J2i2
// module chunks = 1